import React, {useContext, useState} from 'react';
import IframeWidget from "../../utils/IframeWidget";
import {Modal} from "react-bootstrap";
import {usePrefix} from "../../services/Prefix";
import {useNavigate} from "react-router-dom";
import ItemViewHelper from "../../services/Menu/services/Item/ItemViewHelper";
import {useTranslation} from "react-i18next";
import {VoucherProductsContext} from "../../services/VoucherProducts/VoucherProductsContext";
import PromotionItemAddModal from "./PromotionItemAddModal";
import MenuCategoryProduct from "../../pages/Menu/components/Category/MenuCategoryProduct";
import {ConfigApi, MenuProductViewType} from "../../services/Api/types";
import ItemAvailabilityHelper from "../../services/Menu/services/Item/ItemAvailabilityHelper";
import StoreUtils from "../../services/Store/StoreUtils";
import AppConfig from "../../services/AppConfig";

interface Props {
    show: boolean;
    onHide: () => void;
    promotions: any[];
    availabilities: any[];
    session: any;
    cart: any;
    isStorePaused: boolean;
    menus: any;
    categories: any[];
    usePromotionItemModal?: boolean;
    items: any[];
    itemGroups: any[];
    locale: string | undefined;
    config: ConfigApi | undefined;
}

const VoucherProductsModal = ({
                                  show,
                                  onHide,
                                  promotions,
                                  availabilities,
                                  session,
                                  cart,
                                  isStorePaused,
                                  menus,
                                  usePromotionItemModal,
                                  items,
                                  itemGroups,
                                  locale,
                                  categories,
                                  config
                              }: Props) => {
    const prefix = usePrefix();
    const navigate = useNavigate();
    const {t} = useTranslation();
    const {promotionItems, handleRemovePromotion} = useContext(VoucherProductsContext);
    const [promotionItem, setPromotionItem] = useState<Record<string, any> | undefined>();
    const isMultilevelMenu = StoreUtils.isMultilevelMenu(config);

    if (isStorePaused) return null;

    const handleOnHide = async () => {
        if (!hasAnyPromotionItemsInCart()) {
            await handleRemovePromotion();
        }
        IframeWidget.onHide(onHide);
    }

    const hasAnyPromotionItemsInCart = () => {
        const itemsIds = promotionItems.map(item => item.id);

        return cart.items.some((cartItem: any) => itemsIds.includes(cartItem.item_id));

    }

    const findMenuForItem = (item: Record<string, any>) => {
        const itemCategory = ItemAvailabilityHelper.getCategoryWithNearestAvailableDateForItem(item, categories, menus, session, undefined);

        if (!itemCategory) return undefined;

        return menus.find((menu: Record<string, any>) => menu.categories.find((menuCategory: Record<string, any>) => menuCategory.category_id === itemCategory.id))?.id;
    }


    const handleAddItem = (item: Record<string, any>) => {
        if (usePromotionItemModal) {
            setPromotionItem(item);
        } else {
            const state = {
                back: true,
                fromVoucher: true
            };
            const menuId = findMenuForItem(item);

            if (isMultilevelMenu && !menuId) return;

            const link = isMultilevelMenu ? `/menu/${menuId}/add/${item.id}` : `/menu/add/${item.id}`;
            navigate(AppConfig.getLinkWithPrefix(link, prefix), {state});
        }
    }

    const handleOnPromotionItemModalHide = () => {
        IframeWidget.onHide();
        setPromotionItem(undefined);
    }

    const handlePromotionItemModalShowChange = (value: boolean) => {
        if (!value) {
            setPromotionItem(undefined);
        }
    };

    const categoryWithNearestAvailableDateForItem = (item: any) => ItemAvailabilityHelper.getCategoryWithNearestAvailableDateForItem(item, categories, menus, session, undefined);

    return (
        <>
            {promotionItem &&
                <PromotionItemAddModal items={items} menus={menus} itemId={promotionItem.id}
                                       setShow={handlePromotionItemModalShowChange}
                                       vouchers={[]} show={!!promotionItem} onHide={handleOnPromotionItemModalHide}
                                       cart={cart} itemGroups={itemGroups} preventRemovePromotionOnHide/>}

            <Modal dialogClassName={"modal-full voucher-products-modal"} show={show} onHide={handleOnHide}
                   onShow={() => IframeWidget.onShow()}
                   aria-labelledby="voucher_products_modal_title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="voucher_products_modal_title">
                        {t("modules.voucher.field.choose_product.title")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-column w-100 menu-items menu-items-grid">
                        {
                            promotionItems.map((item, index) => {
                                const parsedItem = ItemViewHelper.parseItem(item, availabilities, promotions, session.pickup_at, undefined, cart, session.order_type);
                                const category = categoryWithNearestAvailableDateForItem(item);

                                if (!category) return <></>;

                                return (
                                    <React.Fragment key={item.id}>
                                        <MenuCategoryProduct
                                            product={parsedItem}
                                            promotions={promotions}
                                            addItem={() => handleAddItem(item)}
                                            viewType={MenuProductViewType.VERTICAL_SMALL_IMAGE}
                                            availabilities={availabilities}
                                            session={session}
                                            category={category}
                                            locale={locale}
                                        />
                                        {index !== promotionItems.length - 1 && <hr/>}
                                    </React.Fragment>
                                )
                            })
                        }
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default VoucherProductsModal;